/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatSlowModeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVR4nN1UsUoDQRCNooixEBv/wUZEtBEhVSCQnZ054TITsc4vWFhEkIAgiqUfoKLiL8Sk9B+MGBuL2EVRG1HGXMIldyR3SSoXppndfW/2zZtNJP71ymQyM9Zh1yJfWuRHIGkCygeg1ADlXPdSqdTUUOBAvGWR65bkZ0A8AzHGwZ4AlNMIwD/+AJTjYrE4GaXyk7jg1kfSF9xgnoYFt14oRih4oVCYVj1HJbDIdcUKEFgnJyODkxcOuyHay9W4CIDkIkiAUhvbC0geghKRfI2PgN+DBMif8W3JL4C8j7i94rruvDEmCSDLoT3QryCmW66z2e2FfrbvIZCbGBLctqdWvwmLXFVZNICkgpiHEWzKryqH17fDPmdLgZ8TSJ4iEOx1KvflEXnDUH6z265seqzKu4MIjJNb9XpW9ed9bvTPw10H3HF2FqM0Op3emWsVI2+hBCgNH0HzL+m67iwQ30fpgTEmGUZgraxpXl8YIADis6gOMk5uvXVHKt22lYaCE/ESIH97Vi63dTvqJAcNF0lO76gVB553JBt5TkJnh6TUZ8oPRgJvL7WiukV78tcX5LK/8l8TTbn0JGiqZAAAAABJRU5ErkJggg==)
 */
export const ChatSlowModeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 22c.32 0 .52-.33.41-.63A6.99 6.99 0 0 1 19 12c.83 0 1.63.14 2.37.41.3.1.63-.1.63-.41a10 10 0 1 0-18.45 5.36c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M24 19a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-5-3a1 1 0 0 1 1 1v1.59l.7.7a1 1 0 1 1-1.4 1.42l-1-1A1 1 0 0 1 18 19v-2a1 1 0 0 1 1-1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
